<template>
  <el-form label-width="80px" label-position="left"  size="small" @submit.native.prevent>
    <el-dialog :visible="visible" title="指派订单" width="470px" v-on="$listeners" v-bind="$attrs" @close="onClose">

      <el-form-item label="订单编号"> {{ item.trade_id }} {{ item.paystatus == 1 ? '已' : '未' }}结算 </el-form-item>
      <el-form-item label="订单名称" size="mini">
        <app-link :to="`https://item.taobao.com/item.htm?id=${item.num_iid}`">{{ item.item_title }}</app-link>
      </el-form-item>

      <el-form-item label="指派代理" v-if="agent_list.length">
        <el-select v-model="telephone" filterable remote :remote-method="remoteMethod">
          <el-option
            v-for="item in selectQueryList"
            :key="item.id"
            :label="item.telephone +' '+ (item.nickname || '')"
            :value="item.telephone"
          >
          </el-option>
        </el-select>
        
      </el-form-item>

      <el-table :data="[item]" size="small">
        <el-table-column label="结算总佣金" prop="commission"></el-table-column>
        <el-table-column label="买家" prop="owner_cms_member_commission"></el-table-column>
        <el-table-column label="一级" prop="buyer_inv1_cms_member_commission"></el-table-column>
        <el-table-column label="二级" prop="buyer_inv2_cms_member_commission"></el-table-column>
        <el-table-column label="我的佣金" prop="tbk_commission"></el-table-column>
      </el-table>

      <template slot="footer">
        <zt-button size="medium" min-width="100px" type="primary" @click="onSubmit">确定</zt-button>
      </template>

    </el-dialog>
  </el-form>
</template>

<script>
import { taoke_cms_member_list } from '@/api/userManage'
import { taoke_order_assign, taoke_ddk_order_assign, taoke_jd_order_assign} from '@/api/finance'
import taoke_duomai_order_assign from '@/api/taoke_duomai_order_assign'


export default {
  name: 'AssignDialog',

  props: {
    visible: Boolean,
    orderType:String,
    item: {
      type: Object,
      default: () => ({
        trade_id: '',
        paystatus: '',
        num_iid: '',
        item_title: '',
      }),
    },
  },

  data: () => ({
    telephone: '',
    agent_list: [],
    selectQueryList: [],  // select搜索符合条件的item
  }),

  methods: {

    // 选择了指派会员
    onSelectAgent(item) {
      this.telephone = item.telephone
    },
    //获取指派接口
    async getAssignApi(params) {
      if(this.orderType=='taobao') {
        const res = await taoke_order_assign(params)
        return res
      }else if(this.orderType=='pdd') {
        const res = await taoke_ddk_order_assign(params)
        return res
      }else if(this.orderType == 'jd') {
        const res = await taoke_jd_order_assign(params)
        return res
      }else if(this.orderType == 'duomai') {
        const res = await taoke_duomai_order_assign(params)
        return res
      }
    },
    // 确定指派
    async onSubmit() {
      const { data } = await this.getAssignApi({ id: this.item.id, telephone: this.telephone })

      if (data.error_code != 0) {
        this.$message.error(data.error_message)
      }
      else {
        this.$message.success('指派成功')
        this.$emit('success')
        this.onClose()
      }

      
    },

    onClose() {
      this.telephone = ''
      this.$emit('update:visible', false)
    },

    // 指派人输入框回调
    remoteMethod(query) {
      this.selectQueryList = this.agent_list.filter((o) => {
        if (query !== '') {
          const nickname = o.nickname || ''
          const telephone = o.telephone || ''
          return nickname.includes(query) || telephone.includes(query)
        }
        return true
      })
    },

    // 获取会员列表
    async getAgent() {
      
      const { data } = await taoke_cms_member_list({ lock: 0, pagesize: 9999999, is_agent: 1 })

      if (data.error_code != 0) {
        this.$message.error(data.error_message)
      }
      else {
        this.agent_list = data.list
        this.selectQueryList = data.list
      }

      return data
    },
  },

  created() {
    this.getAgent()
  },
}
</script>

<style lang="scss" scoped>
.el-autocomplete {
  max-width: 230px;
  width: 100%;
}
.app-link {
  color: $theme;
}
</style>